
export default {
    methods : {
        getHeader(headers) {
            return headers.map(header => ({
                text: header[0],
                value: header[1],
                align: 'center',
                class: 'headers text-no-wrap',
                divider: true,
                fixed: true
            }))
        },
        // value -> text 로 변환해서 보여주기
        dataConversion(list, data) {
            if (list.length < 1 || !data) return "";
            const findItem = list.find(item => item.value === data);
            if (findItem) {
                return findItem.text;
            }
            return data;
        },
        setDate(date) {
            if (!date) return "";
            const now = new Date(date);
            return now.toLocaleString();
        },
        setTelNum(telNum) {
            if(!telNum) return "";
            return telNum.length === 11 ? `${telNum.slice(0, 3)}-${telNum.slice(3, 7)}-${telNum.slice(7)}` : telNum;
        },
        setDotsTelNum(telNum) {
            if (!telNum) return "";
            return telNum.slice(0, 3) + "*".repeat(telNum.length - 3);
        },
        setSsnoMasking(ssno) {
            if (!ssno) return "";
            return ssno.slice(0, 6) + "-" + ssno.slice(6, 7) + "******";
        },
        setSsnoNoMasking(ssno) {
            if (!ssno) return "";
            return ssno.slice(0, 6) + "-" + ssno.slice(6);
        },
        setBankAccountMasking(num) {
            if (!num) return "";
            const str = String(num);
            const visibleLen = 5;

            if (str.length <= visibleLen) {
                return str;
            }
            return str.slice(0, visibleLen) + "*".repeat(str.length - visibleLen);
        },
        // 금액 콤마 추가(3자리 마다)
        inputComma(num) {
            if(!num) return 0;
            num = num.toString().replace(/[^\d.-]/g, '');
            return num && num.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        },
        overLengthText(str, maxLength) {
            if(!str) return "";
            if (str.length > maxLength) {
                return `${str.slice(0, maxLength)}...`
            }
            return str;
        },
        setLoanBrokerNoFormat(number) {
            if (!number) return "";
            if (number.length < 10) return number;
            return `${number.slice(0, 2)}-${number.slice(2)}`
        },
        toPercent(num, fixNum) {
            if (!num && num !== 0) return "0.00%";
            return (num * 100).toFixed(fixNum) + "%";
        }
    }
}